module.exports = __webpack_public_path__ + "media/images/room_menu_icon/operation_jobs-0d32f511af65863249cdf05ac87e988a.png";